import React from "react";
import { Switch, Route } from "react-router-dom";
import DashboardContainer from "../containers/dashboardContainer";


function RouterDashboard() {
    return (
        <Route path="/Dashboard">
            <Switch>
                <Route path="/Dashboard" exact>
                    <DashboardContainer />
                </Route>
            </Switch>
        </Route>
    );
}
export default RouterDashboard;